module.exports = __webpack_public_path__ + "img/17.04013fdd.png";